export default "__VITE_ASSET__Cwt3rsCI__";